export default __webpack_public_path__ + "static/riksdagen2-c596065c99b4d6a1ed68adc5e2316ea2.jpg";